/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit EventAction/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import ActionType from './ActionType/index'
import AddAction from './AddAction/index'
import AppointmentRequirements from './AppointmentRequirements/index'
import Content from './Content/index'
import DeleteAction from './DeleteAction/index'
import DragHandle from './DragHandle/index'
import ExpandAction from './ExpandAction/index'
import React from 'react'
import Skip from './Skip/index'
import TysiaHorizDivider from 'DesignSystem/TysiaHorizDivider/index'
import TysiaSubtract from 'DesignSystem/Svgs/TysiaSubtract/index'
import Wait from './Wait/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function EventAction({
  children,
  dragHandleProps,
  isDragging,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction"
  
}) {
let eventActionLevelValueData = fromData.useDataValue({ viewPath,
context: 'event_action',
path: 'level',
})
let constantData = 1
let aggregateData = fromAggregate.equals(eventActionLevelValueData, constantData)
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let eventActionLevelValueData1 = fromData.useDataValue({ viewPath,
context: 'event_action',
path: 'level',
})
let constantData1 = 1
let aggregateData1 = fromAggregate.equals(eventActionLevelValueData1, constantData1)
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
let eventActionTypeValueData = fromData.useDataValue({ viewPath,
context: 'event_action',
path: 'type',
})
let constantData2 = 'wait'
let aggregateData2 = fromAggregate.equals(eventActionTypeValueData, constantData2)
let eventActionLastGroupItemValueData = fromData.useDataValue({ viewPath,
context: 'event_action',
path: 'lastGroupItem',
})
let eventActionLevelValueData2 = fromData.useDataValue({ viewPath,
context: 'event_action',
path: 'level',
})
let constantData3 = 1
let aggregateData3 = fromAggregate.equals(eventActionLevelValueData2, constantData3)
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let eventActionTypeValueData1 = fromData.useDataValue({ viewPath,
context: 'event_action',
path: 'type',
})
let constantData4 = 'wait'
let aggregateData4 = fromAggregate.equals(eventActionTypeValueData1, constantData4)
let authAccessTokenDataIsSupportValueData = fromData.useDataValue({ viewPath,
context: 'auth',
path: 'access_token_data.is_support',
})
  return (<React.Fragment
>
<div
  data-testid="EventAction.Horizontal"
  data-view-path={viewPath}
 style={{'--d-1-1sPPxw': aggregateData ? "none" : "flex"}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="EventAction.Vertical"
  data-view-path={viewPath}
 style={{'--bc-2-1sPPxw': dtColorsNeutral200}}
 className={`views-block ${styles.Vertical}`}
/>
<TysiaSubtract
  viewPath={`${viewPath}/TysiaSubtract`}
 fill={dtColorsNeutral400}
 fill2={dtColorsNeutral400}
 marginLeft={-11}
/>
</div>
<fromFlow.When is={aggregateData1}>
<div
  data-testid="EventAction.Vertical:1"
  data-view-path={viewPath}
 style={{'--bc-3-1sPPxw': dtColorsNeutral100}}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 marginTop={0}
 marginBottom={0}
 paddingTop={0}
 paddingBottom={0}
 width="calc(100% - 32px)"
 marginLeft="auto"
 marginRight="auto"
 backgroundColor={dtColorsNeutral200}
/>
</div>
</fromFlow.When>
<div
  data-testid="EventAction.Vertical:2"
  data-view-path={viewPath}
 style={{'--bc-3-1sPPxw': dtColorsNeutral100,'--pt-4-1sPPxw': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-5-1sPPxw': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bc-2-1sPPxw': dtColorsNeutral200,'--bbw-9-1sPPxw': aggregateData2 ? "0px" : eventActionLastGroupItemValueData ? "1px" : aggregateData3 ? "0px" : "1px",'--btw-8-1sPPxw': aggregateData3 ? "0px" : "1px",'--pr-6-1sPPxw': aggregateData3 ? "28px" : typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-7-1sPPxw': aggregateData3 ? "28px" : typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical2}`}
>
<div
  data-testid="EventAction.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<ActionType
  viewPath={`${viewPath}/ActionType`}
/>
<Wait
  viewPath={`${viewPath}/Wait`}
/>
<AppointmentRequirements
  viewPath={`${viewPath}/AppointmentRequirements`}
/>
<Skip
  viewPath={`${viewPath}/Skip`}
/>
<div
  data-testid="EventAction.Horizontal:2"
  data-view-path={viewPath}
 style={{'--g-10-1sPPxw': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal2}`}
>
<AddAction
  viewPath={`${viewPath}/AddAction`}
/>
<div
  data-testid="EventAction.Horizontal:3"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal3}`}
>
<DeleteAction
  viewPath={`${viewPath}/DeleteAction`}
/>
</div>
<DragHandle
  viewPath={`${viewPath}/DragHandle`}
 data="event_action.type"
 data="'wait'"
 aggregate="/Data/aggregate.js equals"
 disabled={aggregateData4}
 data="auth.access_token_data.is_support"
 disabled={!authAccessTokenDataIsSupportValueData}
 dragHandleProps={dragHandleProps}
/>
<div
  data-testid="EventAction.Horizontal:4"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal4}`}
>
<ExpandAction
  viewPath={`${viewPath}/ExpandAction`}
/>
</div>
</div>
</div>
<Content
  viewPath={`${viewPath}/Content`}
/>
</div>
{children}
</React.Fragment>)
}